function calculateSliderWidth() {
  const slider = document.querySelector('.slider-mediacover');
  const images = slider.querySelectorAll('.slider-mediacover.slider-image-mediacover'); // Select only images with the "slider-image" class
  let totalWidth = 0;
  
  images.forEach(image => {
    totalWidth += image.width;
  });

  return totalWidth;
}

function setSliderContainerWidth() {
  const sliderContainer = document.querySelector('.slider-container-mediacover');
  const sliderWidth = calculateSliderWidth();
  
  sliderContainer.style.width = `${sliderWidth}px`;
}

setSliderContainerWidth();



